import { DateTime } from 'luxon'
import { CustomParams, SlidingParams } from '../types/SpyLaunchSettings'

export function spyLaunchSettingsToString(spyLaunchSettings: any){
    if (spyLaunchSettings === undefined){
        return ``
    }

    if (spyLaunchSettings.mode === 'sliding'){
        const params = spyLaunchSettings.params as SlidingParams
        return `Days Ahead: ${params.daysAhead}`
    }

    if (spyLaunchSettings.mode === 'custom'){
        const params = spyLaunchSettings.params as CustomParams
        const startDate = DateTime.fromISO(params.periods[0]?.startDate, { setZone: true })
        const endDate = DateTime.fromISO(params.periods[0]?.endDate, { setZone: true })
        return `${startDate.toFormat('LLL d')} - ${endDate.toFormat('LLL d')}`
    }
}